export const theme_color = '#0267c1';
export const theme_bg = 'rgba(2, 103, 193, 0.1)';
export const nav_bg_color = '#F2F7FC'; 

export const colors = {
    theme_color: '#0267c1'
}